<template>
  <v-card class="mx-auto mt-4 rounded-card" elevation="4" max-width="800">
    <div class="row justify-content-start">
      <v-btn dark class="ma-4 orange" v-if="this.mark" large rounded>{{
        this.mark
      }}</v-btn>
      <v-spacer></v-spacer>

      <div class="row-2 mr-6">
        <v-btn icon color="primary">
          <v-icon class="ma-2" @click="editNews"> mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon color="primary">
          <v-icon class="ma-2" color="red" @click="removeNews"> mdi-delete</v-icon></v-btn
        >
      </div>
    </div>
    <p class="title font-weight-bold text-wrap mr-5" style="color: #000;">{{ this.title }}</p>

    <div class="container">
        <div class="row justify-content-start ml-1">
          <span>
          <v-icon> mdi-calendar</v-icon>
          <label> {{ this.date }} </label>
          </span>
          <!-- <span class="ml-8">
          <v-icon> mdi-web-clock</v-icon>
          <label> {{ this.date }} </label>
          </span> -->
        </div>

      <div class="row justify-content-start">
        <v-card-subtitle><span class="font-weight-black"> Source:</span> {{ this.source }} </v-card-subtitle>
      </div>
    </div>

    <v-card-text class="text-truncate">
      {{ this.body }}
    </v-card-text>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <v-btn @click="show = !show" color="blueblack" text>
            <label>
              {{ show ? "Less" : "More" }}
            </label>
          </v-btn>

          <v-btn icon @click="show = !show">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text>
          {{ this.body }}
        </v-card-text>
      </div>
    </v-expand-transition>
    <v-img v-if="this.image" :src="this.image" height="200px"></v-img>
  </v-card>
</template>
<script>
import { eventBus } from "@/main.js";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  computed: {
    ...mapFields("news", ["allNews", "fakeNews", "currentTab"]),
  },
  data: () => ({
    show: false,
    
  }),
  methods: {
    ...mapActions("news", ["updateNews", "deleteNews", "fetchAllNews", "fetchFakeNews"]),
    ...mapActions("shared", ["populateForm", "showEditForm"]),
    editNews() {
      // get the document to be edited
      // verified/fake
      var found;
      if (this.currentTab === 0) {
        found = this.allNews.find((element) => element.id === this.id);
      } else {
        found = this.fakeNews.find((element) => element.id === this.id);
      }

      this.populateForm({
        payload: {
          formdata: {
            id: found.id,
            body: found.content.body,
            date: found.content.date,
            image: found.content.image,
            likes: found.content.likes,
            source: found.content.source,
            title: found.content.title,
            views: found.content.views,
          },
        },
      });
      // set the form as Edit form
      this.showEditForm({
        payload: {
          isEdit: true,
        },
      });
      eventBus.$emit("formChangeEvent", true);
      eventBus.$emit("dialogToggle", true);
    },
    async removeNews() {
      // check path as verify / fake
      var path;
      if (this.currentTab === 0) {
        path = "all_news/";
      } else {
        path = "fake_news/";
      }
      // get the document to be delted
      // verified/fake
      var found;
      if (this.currentTab === 0) {
        found = this.allNews.find((element) => element.id === this.id);
      } else {
        found = this.fakeNews.find((element) => element.id === this.id);
      }

      try {
        await this.deleteNews({
          payloadPath: path,
          payloadId: found.id,
          lang: this.lang,
        });
        await this.fetchAllNews(this.lang)
        await this.fetchFakeNews(this.lang);

        alert("Successfully Deleted News!");
        // location.reload();
      } catch (error) {
        alert("Failed to delete News!");
      }
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    lang: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: false,
    },
    source: {
      type: String,
      required: false,
    },
    body: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: false,
    },
    mark: {
      type: String,
      required: false,
    },
  },
};
</script>